module.exports = __webpack_public_path__ + "img/서브5_시야.02e0e895.svg";